<div id="not-found-container">
    <h2>404</h2>
    <p>La página que buscas no pudo ser encontrada</p>
</div>